module.exports = __webpack_public_path__ + "img/link.f50d4324.svg";